module.exports = __webpack_public_path__ + "static/media/1-1.7188e63e.png";